import { Viewer, Worker } from '@react-pdf-viewer/core'
import '@react-pdf-viewer/core/lib/styles/index.css'
import React from 'react'
import styled from 'styled-components'
import Loader from '../../components/Loader'
import NotFound404 from '../../components/NotFound404'

//
const PdfViewer: React.FC<{
  url?: string
}> = ({ url }) => {
  return !url ? (
    <NotFound404 />
  ) : (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <Box>
        <Viewer
          fileUrl={url}
          renderLoader={() => (
            <Loader
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            />
          )}
        />
      </Box>
    </Worker>
  )
}
//
const Box = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
//
export default PdfViewer
